import React, { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';

import { CustomButton } from './CustomButton';
import CustomModal from './CustomModal';
import TextField from '@mui/material/TextField';

import AIManual from '../assets/AI_Manual.pdf';
import AIManualScreenshot from "../assets/AI_Manual_Screenshot.png"
import { sendEbookContact } from '../services/contact';

import './EbookModal.css';

const EbookModal = ({ closeModal }) => {

    const [email, setEmail] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [buttonDisabled, setButtonDisabled] = useState(true);

    const [showDownloadButton, setShowDownloadButton] = useState(false);

    const textFieldInputProps = {
        fontSize: "15px",
        fontWeight: 400,
        fontFamily: "Inter",
        paddingLeft: "15px",
        paddingRight: "10px",
        backgroundColor: "white",
        borderRadius: "6px",
    }

    function verifyEmail(emailInput) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput);
    }

    async function submitForm() {
        setButtonDisabled(true);
        const status = await sendEbookContact(companyName, email, phone, name);
        console.log("status", status)
        if (status !== 200) {
            alert('Something went wrong. Please try again later.');
            return;
        }

        // Send the Google tracking data
        TagManager.dataLayer({
            dataLayer: {
                event: 'sp-labs-contact',
            }
        });

        setShowDownloadButton(true);
    }

    useEffect(() => {
        if (email.length > 0 && companyName.length > 0 && phone.length > 7 && name.length > 0) {
            const isValidEmail = verifyEmail(email);
            if (isValidEmail) {
                setButtonDisabled(false);
            } else {
                setButtonDisabled(true);
            }
        } else {
            setButtonDisabled(true);
        }
    }, [email, companyName, phone, name])

    return (
        <CustomModal
            closeModal={closeModal}
            customModalContainerStyle={{ backgroundColor: "#ebebeb", maxWidth: "900px", width: "90vw" }}
            customMainColStyle={{ paddingTop: "0px" }}
            title={""}
            customTitleStyle={{ fontWeight: 800, fontSize: "32px" }}>

            <div className="ebook-modal-section">

                <p className="ebook-title">Download The AI Manual now</p>

                <div className="ebook-modal-container">

                    <div className="ebook-screenshot-col">
                        <img src={AIManualScreenshot} id="ebook-screenshot" />
                    </div>


                    <div className="ebook-inputs-col">

                        <div className="contact-us-form-row">
                            <div className="ebook-contact-us-form-col">
                                <p className="ebook-input-header">Name</p>
                                <TextField
                                    placeholder='John'
                                    size="small"
                                    type="text"
                                    value={name}
                                    onChange={(event) => setName(event.target.value)}
                                    inputProps={{ style: textFieldInputProps }}
                                />
                            </div>
                        </div>

                        <div className="contact-us-form-row">
                            <div className="ebook-contact-us-form-col">
                                <p className="ebook-input-header">Email address</p>
                                <TextField
                                    placeholder='john@acme.inc'
                                    type="email"
                                    size="small"
                                    value={email}
                                    onChange={(event) => setEmail(event.target.value)}
                                    inputProps={{ style: textFieldInputProps }}
                                />
                            </div>
                        </div>

                        <div className="contact-us-form-row">
                            <div className="ebook-contact-us-form-col">
                                <p className="ebook-input-header">Company name</p>
                                <TextField
                                    placeholder="Acme Inc."
                                    type="text"
                                    size="small"
                                    value={companyName}
                                    onChange={(event) => setCompanyName(event.target.value)}
                                    inputProps={{ style: textFieldInputProps }}
                                />
                            </div>
                        </div>

                        <div className="contact-us-form-row">
                            <div className="ebook-contact-us-form-col">
                                <p className="ebook-input-header contact-us-input-header-bottom">Phone number</p>
                                <TextField
                                    placeholder="123-456-7890"
                                    type="tel"
                                    size="small"
                                    value={phone}
                                    onChange={(event) => setPhone(event.target.value)}
                                    inputProps={{ style: textFieldInputProps }}
                                />
                            </div>
                        </div>

                        {!showDownloadButton && <div className="contact-us-form-button-row">
                            <CustomButton onClick={() => submitForm()} buttonText="Submit" disabled={buttonDisabled} />
                        </div>}

                        {showDownloadButton &&
                            <div className="contact-us-form-button-row">
                                <div className={`download-button-container`}
                                    onClick={() => { buttonDisabled ? console.log("") : submitForm() }}>
                                    <p className="form-submitted-text">{"Form successfully submitted! You can access your eBook "}
                                        <a className="download-text" href={AIManual} target="_blank">here</a>.
                                    </p>
                                </div>
                            </div>
                        }

                    </div>

                </div>

            </div>

        </CustomModal >
    )

}

export default EbookModal;

// <CustomButton onClick={() => submitForm()} buttonText="Download" disabled={buttonDisabled} />
/*
<div className={`download-button-container${buttonDisabled ? "-disabled" : ""}`}
                                onClick={() => { buttonDisabled ? console.log("") : submitForm() }}>
                                <a className="download-button" href={AIManual} target="_blank">Download</a>
                            </div>
                            */